import React, { useEffect, useState } from "react";
import SingleImageSpinner from "../spinner/SingleImageSpinner";
import { RxCross2 } from "react-icons/rx";

const ImageCard = ({
  item,
  retryHandler,
  key,
  handleDeletePhoto,
  handleDefaultMedia,
}) => {
  console.log("render Image card component :", item);
  const [videoUrl, setVideoUrl] = useState("");

  useEffect(() => {
    const url = URL.createObjectURL(item.file);
    setVideoUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [item.file]); 
  return (
    <div key={key}>
      <div className="box-decoration positon-relative">
      {((item.status?.length > 0) || item.isOverSize) && (
        <SingleImageSpinner file={item} retryHandler={retryHandler} />
      )}

        <button className="cross-btn" onClick={() => handleDeletePhoto(item)} style={{ zIndex: "100" }}>
          <RxCross2 className="btn-icons" />
        </button>
        {item.file?.type?.startsWith("image/") ? (
          <img src={videoUrl} alt="Preview" className="images" />
        ) : item.file?.type?.startsWith("video/") ? (
          <video src={videoUrl} controls className="images" />
        ) : (
          <b>{"Invalid File"}</b>
        )}
      </div>

      <div className="default--mark--container">
        <input
          className="form-check-input"
          type="checkbox"
          name="isRecommend"
          checked={item.isDefault}
          onChange={() => handleDefaultMedia(item.id)}
        />
        <label className="img--default--text">{"Mark as Default"}</label>
      </div>
    </div>
  );
};

export default React.memo(ImageCard);
